import styled from 'styled-components'

export const Header = styled.p`
  font-size: 21px!important;
  font-weight: bold!important;
`

export const SocialMediaButton = styled.button`
  flex: 1;
  &:hover {
    border: 1px solid #6297FF!important;
  }
  &:focus {
    color: #363636!important;
  }
  border: 1px solid #D5DEF1!important;
  border-radius: 8px!important;
  height: 44px!important;
  align-items: center;
  padding: 0!important;
  font-weight: 600!important;
  font-size: 13px!important;
`